export const isServerMaintenanceResponse = (input: { status: number }): boolean => {
	// This is a unique HTTP code we have chosen to represent server maintenance
	return input.status === 542;
};
